import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../layouts/Modal';
import Button from '../misc/Button';

interface ConfirmLogoutModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
}

export default function ConfirmLogoutModal({ open, setOpen, onConfirm }: ConfirmLogoutModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal open={open} setOpen={setOpen} title={t('auth.logoutConfirmTitle')} maxWidth="max-w-md">
      <p className="mb-6 text-sm text-details/50">{t('auth.logoutConfirmDescription')}</p>
      <div className="flex justify-end gap-3">
        <Button variant="secondary" onClick={() => setOpen(false)}>
          {t('auth.logoutConfirmCancel')}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            onConfirm();
            setOpen(false);
          }}>
          {t('auth.logoutConfirmConfirm')}
        </Button>
      </div>
    </Modal>
  );
}
